import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { JobPosting } from '@app/models/recruiting/job-posting.model';

export class LocationColumn extends Column {
    title = 'applicant-tracker.location';
    property = 'city';
    sortField = 'city';
    sortable = true;
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(jobPosting: JobPosting): string {
        return jobPosting.city ?? 'N/A';
    }
}
